import { ArrowStatefulIcon } from '@mm/icons';
import classnames from 'classnames';
import React from 'react';
import { colors } from '../../../editor/features/beta/styles/colors';
import { Pagination } from '@mm/state/store-interfaces';
import { getPagingRange } from './getPagingRange';
import { PageNumber } from './PageNumber';
import './PaginationNav.scss';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

type OuterProps = {
  pagination: Pagination;
  onChangePage: (page: number) => void;
  rangeLength?: number;
  className?: string;
  circularActive?: boolean;
  squareActive?: boolean;
  withEllipsis?: boolean;
};

type Props = OuterProps;

const PaginationNav = (props: Props) => {
  const {
    pagination,
    onChangePage,
    rangeLength = 7,
    className,
    circularActive,
    squareActive,
    withEllipsis,
  } = props;

  if (!pagination || pagination.totalPages <= 1) {
    return null;
  }

  const { totalPages } = pagination;
  const activePage = pagination.page;
  const pages = getPagingRange(
    activePage,
    totalPages,
    rangeLength,
    withEllipsis,
  );

  const mainClassList = classnames('pagination-nav', className);
  const previousClassList = classnames('pagination-nav__next-prev-link', {
    'pagination-nav--disabled': activePage <= 1,
    'pagination-nav-square': squareActive,
  });
  const nextClassList = classnames('pagination-nav__next-prev-link', {
    'pagination-nav--disabled': activePage >= totalPages,
    'pagination-nav-square': squareActive,
  });

  return (
    <div className={mainClassList}>
      {!squareActive && (
        <span
          className="pagination-nav__next-last-text"
          onClick={() => onChangePage(1)}
        >
          First
        </span>
      )}
      <div
        className={previousClassList}
        onClick={() => onChangePage(activePage - 1)}
      >
        {squareActive && <LeftOutlined />}
        {!squareActive && (
          <ArrowStatefulIcon
            className="pagination-nav__arrow"
            direction="left"
            color={colors.accentBlue}
            size={16}
          />
        )}
      </div>

      {pages.map(([page, label]) => (
        <PageNumber
          key={page}
          page={page}
          label={label}
          onChangePage={onChangePage}
          activePage={activePage}
          circularActive={circularActive}
          squareActive={squareActive}
        />
      ))}

      <div
        className={nextClassList}
        onClick={() => onChangePage(activePage + 1)}
      >
        {squareActive && <RightOutlined />}
        {!squareActive && (
          <ArrowStatefulIcon
            className="pagination-nav__arrow"
            direction="right"
            color={colors.accentBlue}
            size={16}
          />
        )}
      </div>
      {!squareActive && (
        <span
          className="pagination-nav__next-last-text"
          onClick={() => onChangePage(totalPages)}
        >
          Last
        </span>
      )}
    </div>
  );
};

export { PaginationNav };
